<div class="root-container">
  <div class="root-container-main">
    <router-outlet></router-outlet>
  </div>
  <xpo-footer xpoFooterSticky [version]="build">
    <a [href]="feedbackAddress" >
      Feedback
    </a>
  </xpo-footer>
</div>